import { render, staticRenderFns } from "./priority-rq.vue?vue&type=template&id=640de8a1&scoped=true"
import script from "./priority-rq.vue?vue&type=script&lang=js"
export * from "./priority-rq.vue?vue&type=script&lang=js"
import style0 from "./priority-rq.vue?vue&type=style&index=0&id=640de8a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640de8a1",
  null
  
)

export default component.exports